import { defineMessages } from "react-intl";

const messages = defineMessages({
  cancel: {
    id: "app.cancel",
    description: "Cancel",
    defaultMessage: "Cancel",
  },
  ok: {
    id: "app.ok",
    description: "ok",
    defaultMessage: "Ok",
  },
  success: {
    id: "app.success",
    description: "Success message",
    defaultMessage: "Success!",
  },
  failed: {
    id: "app.failed",
    description: "Failed message",
    defaultMessage: "Failed!",
  },
  selectAll: {
    id: "app.entityForm.selectAll",
    description: "Select all",
    defaultMessage: "Select all",
  },
  selectNone: {
    id: "app.entityForm.selectNone",
    description: "Select none",
    defaultMessage: "Select none",
  },
  requireAtLeastOneRestriction: {
    id: "app.form.needsAtLeastOneCondition",
    description: "Fields needs at least 1 Text",
    defaultMessage: "Configurations needs at least 1",
  },
  editByExcel: {
    id: "app.entityForm.editByExcel",
    description: "Edit by excel",
    defaultMessage: "Edit by excel",
  }
});

export default messages;
